<template>
  <div class="ContactUs maxWidth">
    <div class="ContactUs-leftBox">
      <div class="ContactUs-leftBanner"></div>
      <div class="ContactUs-leftText">
        <span class="title">立即获取适合您的互联网智能化解决方案</span>
        <span class="title1"
          >可直接拨打电话<span style="color: #E1251A">186-3037-6696</span></span
        >
        <span class="title2">感谢您关注河北星巢信息技术有限公司！</span>
      </div>
    </div>
    <div class="ContactUs-rightBox">
      <div class="ContactUs-rightBanner"></div>
      <div class="rightContactUs">
        <div class="rightContactUs-left">
          <div class="rightContactUs-leftBox">
            <span>在线留言咨询 </span>
            <span>在线留言获取售前专业咨询</span>
          </div>
          <button type="button" @click="clickParent">立即咨询</button>
          <ZXDialog ref="mychild" />
        </div>
        <div class="rightContactUs-right">
          <div class="rightContactUs-leftBox">
            <span>微信关注我们 </span>
            <span>专业产品顾问，随时随地沟通</span>
          </div>
          <img src="../assets/erweima.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ZXDialog from "../components/ZXDialog.vue";
export default {
  name: "ContactUs",
  components: { ZXDialog },

  methods: {
    clickParent() {
      this.$refs.mychild.parentHandleclick();
    }
  }
};
</script>

<style scoped>
.maxWidth {
  max-width: 100%;
}
.ContactUs {
  position: relative;
  height: 250px;
  width: 1920px;
  margin: 0 auto;
  background: linear-gradient(60deg, #e9eef4, #e4e8f1);
  display: flex;
  justify-content: space-between;
  /* background-color: red; */
}
.ContactUs-leftBox,
.ContactUs-rightBox {
  position: relative;
}
.ContactUs-leftBanner {
  position: absolute;
  top: 18px;
  left: 92px;
  width: 282px;
  height: 214px;
  background-image: url("~../assets/footer-left.png");
  background-repeat: no-repeat;
  background-size: 100%;
}
.ContactUs-leftText {
  display: flex;
  flex-direction: column;
  padding-left: 318px;
  padding-top: 67px;
  /* align-items: center; */
}
.ContactUs-leftText .title {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #00000c;
  margin-bottom: 17px;
}
.ContactUs-leftText .title1 {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #454647;
  margin-bottom: 49px;
}
.ContactUs-leftText .title2 {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  /* line-height: 6px; */
}
.ContactUs-rightBanner {
  position: absolute;
  right: 0;
  width: 456px;
  height: 250px;
  background-image: url("~../assets/footer-right.png");
  background-repeat: no-repeat;
  background-size: 100%;
}
.rightContactUs {
  position: relative;
  right: 292px;
  top: 58px;
  width: 818px;
  height: 192px;
  background: rgba(255, 255, 255, 0.4);
  border: 1px solid #ffffff;
  border-radius: 14px 14px 0px 0px;
  padding: 46px 25px 46px 39px;
  box-sizing: border-box;
  display: flex;
}
.rightContactUs-left {
  width: 50%;
  display: flex;
  border-right: 1px solid #c8cbd1;
  align-items: center;
  padding-right: 20px;
}
.rightContactUs-leftBox {
  display: flex;
  flex-direction: column;
  margin-right: 43px;
}
.rightContactUs-leftBox span:first-child {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  margin-bottom: 17px;
}
.rightContactUs-leftBox span:last-child {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  white-space: nowrap;
}
.rightContactUs-left > button {
  width: 100px;
  height: 34px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
}
.rightContactUs-right {
  padding-left: 40px;
  box-sizing: border-box;
  align-items: center;
  display: flex;
}
.rightContactUs-right .erweima {
  display: block;
  width: 107px;
  height: 107px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactUs.vue